import type { ActionTree, GetterTree } from "vuex";
import type { IDataState } from "@/store/modules/data";
import { DataModules } from "@/store/modules/data/modules";
import type { ApiPathGetter } from "@upmind-automation/types";
import type { IState } from "@/store";

/**
 * Admin user login attempts (IP logging) — FE-1293.
 */

const initialState = {} as IDataState;

const getters: GetterTree<IDataState, IState> = {
  apiPath: (): ApiPathGetter => () => {
    const admin = "api/admin/users/login_attempts";
    return { admin };
  }
};

const actions: ActionTree<IDataState, IState> = {
  list: ({ dispatch, getters }, payload) => {
    return dispatch(
      "data/list",
      {
        ...payload,
        path: getters.apiPath().admin,
        params: {
          ...payload?.params,
          // The endpoint is not user-scoped by path, so identify the user
          // via an object_id filter.
          ...(payload?.object_id
            ? { "filter[object_id]": payload.object_id }
            : {})
        },
        splitCount: true,
        storeModule: DataModules.USERS_LOGIN_ATTEMPTS
      },
      { root: true }
    );
  }
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions
};
